import React, { Component } from 'react';
import moment from 'moment';

import Header from '../components/Header';
import SideMenu from '../components/SideMenu';

import TimelineFilter from '../components/TimelineFilter';
import Timeline from '../components/Timeline';
import TimelineApi from '../psuite-js/apis/delivery/event';

import Snackbar from 'material-ui/Snackbar';

class TimelineContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            events: [],
            error: false,
            fetched_data: false
        }
    }

    fetchData(filter = {}) {
        this.setState({loading: true});

        const date = (filter.date) ? moment(filter.date) : moment();

        let params = {};

        let document_id = filter.document_id;
        if (document_id) {
            params = {
                order: [['date', 'ASC']],
                filter: {
                    document_id: {
                        $eq: document_id
                    }
                }
            };
        } else {
            params = {
                order: [['date', 'ASC']],
                filter: {
                    date: {
                        $gte: date.format('YYYY-MM-DD'),
                        $lte: date.add(1, 'day').format('YYYY-MM-DD')
                    },

                    vehicle_id: {
                        $eq: (filter.vehicle_id || '').toUpperCase()
                    }
                }
            };
        }

        TimelineApi.all(params).then(result => {
            this.setState({events: result.data.data, loading: false, fetched_data: true});
        }).catch(e => {
            console.error(e);
            this.setState({events: [], loading: false});
            alert('Falha ao recuperar os dados!');
        });
    }

    render() {

        return (
            <div>
                <Header />

                <div className="container-fw">
                    <SideMenu />

                    <div className="content">
                        <div className="side-filter">
                            <TimelineFilter onSubmit={this.fetchData.bind(this)} />
                        </div>

                        <div className="flex-container">
                            <Timeline data={this.state.events} fetched_data={this.state.fetched_data} />
                        </div>

                        <Snackbar
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            open={this.state.loading}
                            message={<span>Carregando...</span>}
                        />
                    </div>
                </div>
            </div>
        );
    }

}

export default TimelineContainer;



// WEBPACK FOOTER //
// ./src/containers/timeline.js